import { HeartBank } from "../managers/HeartBank.ts";
import { Kiitti } from "../models/Kiitti.ts";
import { Hero } from "../managers/Hero.ts";
import { Hero as User } from "../managers/User.ts";
import { Me } from "../managers/Me.ts";
import {
    B,
    getHero,
    isPopup,
    isRunningAsPWA,
    isTip,
    isBroadcast,
    isSos,
    isSidekick,
    isRecord,
    enableTapAndLongPress,
    getAdverb,
    wait,
    ringColors,
    getRecommendedTipAmount,
    getAuraColor,
    getKiitosAuraColor,
    getKiittiAuraColor,
    getKiitosAuraSize,
    getKiittiAuraSize,
    getAuraEmoji,
    getAuraName,
    getRandomNumber,
    getAddress,
    getPosition,
    haversineMiles,
    isProduction
} from "./global.ts";

import { Tokens } from "../models/Thanks.ts";
import Grams from "../models/Grams.json";
type Gram = {
    tip: string;
    moment: string;
    pair: string;
    local: string[];
    live: string[];
};
const grams = Grams as Record<string, Gram>;

import { HbMe } from "./hb-me/hb-me.ts";
//import { HbMe as HbMe2 } from "./hb-me/hb-me2.ts";
import { HbAvatar } from "./hb-avatar/hb-avatar.ts"; //TODO: move to hb-b folder ??
import { HbHeader } from "./hb-header/hb-header.ts";
import { HbMain } from "./hb-main/hb-main.ts";
import { HbFooter } from "./hb-footer/hb-footer.ts";
import { HbMap } from "./hb-main/hb-map/hb-map.ts";
import { Stamps } from "../models/Stamps.ts";
import { FamilyBank } from "../managers/FamilyBank.ts";

customElements.define("hb-me", HbMe);
//customElements.define("hb-me2", HbMe2);
customElements.define("hb-avatar", HbAvatar);
customElements.define("hb-main", HbMain); // order important!
customElements.define("hb-header", HbHeader);
customElements.define("hb-footer", HbFooter);
customElements.define("hb-map", HbMap);

const avatar = new URL("../public/avatar.webp", import.meta.url).href;

export class HbTreasury extends HTMLBodyElement {
    private heartbank = new HeartBank();
    private familyBank = new FamilyBank();
    private kiitti = new Kiitti();
    private stamps = new Stamps();
    private thanks = new Tokens();
    private hero = new Hero();
    private me = new Me();
    private user: User | null = null;

    private header: HbHeader;
    private main: HbMain;
    private footer: HbFooter;
    private footerContent: HTMLElement;

    private kiitosSign: HTMLSpanElement;
    private kiitosKarat: HTMLSpanElement;
    private kiittiSign: HTMLSpanElement;
    private kiittiKarat: HTMLSpanElement;
    private account: HTMLSpanElement;
    private fund: HTMLSpanElement;

    private heart: HTMLElement;
    private heartButton: HTMLButtonElement;
    private heartButtons: HTMLElement;
    private heartThank: HTMLButtonElement;
    private heartGift: HTMLButtonElement;
    private heartPouch: HTMLButtonElement;
    private heartTreasure: HTMLButtonElement;
    private heartChest: HTMLButtonElement;
    private heartKiitos: HTMLButtonElement;
    private heartBroadcast: HTMLButtonElement;
    private heartLeaderboard: HTMLButtonElement;

    private heroes: HTMLElement;
    private tokens: HTMLElement;
    private redToken: HTMLButtonElement;
    private orangeToken: HTMLButtonElement;
    private yellowToken: HTMLButtonElement;
    private greenToken: HTMLButtonElement;
    private blueToken: HTMLButtonElement;
    private indigoToken: HTMLButtonElement;
    private violetToken: HTMLButtonElement;

    private bank: HTMLElement;
    private bankButtons: HTMLElement;
    private bankButton: HTMLButtonElement;
    private bankSend: HTMLButtonElement;
    private bankDeposit: HTMLButtonElement;
    private bankWithraw: HTMLButtonElement;
    private bankCash: HTMLButtonElement;
    private bankTeller: HTMLButtonElement;
    private bankPool: HTMLButtonElement; // donate
    private bankBlast: HTMLButtonElement; // donate to all nearby!
    private bankTip: HTMLButtonElement; // auto tip
    private bankPrice: HTMLButtonElement;

    private map: HbMap;
    private tree: HTMLElement; // HbTree
    private earth: HTMLElement;
    private earthButton: HTMLButtonElement;
    private earthButtons: HTMLElement;
    private earthTree: HTMLButtonElement;
    private earthPixxiKat: HTMLButtonElement;
    private earthEmoji: HTMLButtonElement;
    private earthGif: HTMLButtonElement;
    private earthLink: HTMLButtonElement;
    private earthPost: HTMLButtonElement;
    private earthSecrets: HTMLButtonElement;
    private earthTrove: HTMLButtonElement;

    private feedback: HTMLElement;
    private feedbackButtons: HTMLElement;
    private feedbackButton: HTMLButtonElement;
    private feedbackBug: HTMLButtonElement;
    private feedbackSuggestion: HTMLButtonElement;
    private feedbackHelp: HTMLButtonElement;

    // admin only
    private b3: HTMLElement;
    private b3Buttons: HTMLElement;
    private b3Button: HTMLButtonElement;
    private b: SVGElement;
    private broadcast: HTMLButtonElement;
    private sos: HTMLButtonElement;
    private sidekick: HTMLButtonElement;
    private record: HTMLButtonElement;
    private reload: HTMLButtonElement;
    private heartQuest: HTMLButtonElement;

    private hasPasskey = false;
    //private isPool = true;
    private selectedAction: "heart" | "bank" | null = null;
    private selectedHero = ""; // uid
    private banker = ""; // phone

    constructor() {
        super();
        this.header = this.querySelector("hb-header")!;
        this.main = this.querySelector("hb-main")!;
        this.footer = this.querySelector("hb-footer")!;
        this.footerContent = this.querySelector("#hb-footer-content")!;

        this.kiitosSign = this.querySelector("#hb-heart-kiitos-sign")!;
        this.kiitosKarat = this.querySelector("#hb-heart-kiitos-karat")!;
        this.kiittiSign = this.querySelector("#hb-heart-kiitti-sign")!;
        this.kiittiKarat = this.querySelector("#hb-heart-kiitti-karat")!;
        this.account = this.querySelector("#hb-bank-cash-account")!;
        this.fund = this.querySelector("#hb-bank-cash-fund")!;

        this.heart = this.querySelector("#hb-heart-container")!;
        this.heartButton = this.querySelector("#hb-heart-button")!;
        this.heartButtons = this.querySelector("#hb-heart-buttons")!;
        this.heartThank = this.querySelector("#hb-heart-thank")!;
        this.heartGift = this.querySelector("#hb-heart-gift")!;
        this.heartPouch = this.querySelector("#hb-heart-pouch")!;
        this.heartChest = this.querySelector("#hb-heart-chest")!;
        this.heartTreasure = this.querySelector("#hb-heart-treasure")!;
        this.heartKiitos = this.querySelector("#hb-heart-kiitos")!;
        this.heartBroadcast = this.querySelector("#hb-heart-broadcast")!;
        this.heartLeaderboard = this.querySelector("#hb-heart-leaderboard")!;

        this.heroes = this.querySelector("#hb-heroes")!;
        this.tokens = this.querySelector("#hb-tokens")!;
        this.redToken = this.querySelector("#hb-token-red")!;
        this.orangeToken = this.querySelector("#hb-token-orange")!;
        this.yellowToken = this.querySelector("#hb-token-yellow")!;
        this.greenToken = this.querySelector("#hb-token-green")!;
        this.blueToken = this.querySelector("#hb-token-blue")!;
        this.indigoToken = this.querySelector("#hb-token-indigo")!;
        this.violetToken = this.querySelector("#hb-token-violet")!;

        this.bank = this.querySelector("#hb-bank-container")!;
        this.bankButtons = this.querySelector("#hb-bank-buttons")!;
        this.bankButton = this.querySelector("#hb-bank-button")!;
        this.bankSend = this.querySelector("#hb-bank-send")!;
        this.bankDeposit = this.querySelector("#hb-bank-deposit")!;
        this.bankWithraw = this.querySelector("#hb-bank-withdraw")!;
        this.bankCash = this.querySelector("#hb-bank-cash")!;
        this.bankTeller = this.querySelector("#hb-bank-teller")!;
        this.bankPool = this.querySelector("#hb-bank-pool")!;
        this.bankBlast = this.querySelector("#hb-bank-blast")!;
        this.bankTip = this.querySelector("#hb-bank-tip")!;
        this.bankPrice = this.querySelector("#hb-bank-price")!;

        this.map = this.querySelector("hb-map")!;
        this.tree = this.querySelector("#hb-tree")!;
        this.earth = this.querySelector("#hb-earth-container")!;
        this.earthButton = this.querySelector("#hb-earth-button")!;
        this.earthButtons = this.querySelector("#hb-earth-buttons")!;
        this.earthTree = this.querySelector("#hb-earth-tree")!;
        this.earthPixxiKat = this.querySelector("#hb-earth-pixxikat")!;
        this.earthEmoji = this.querySelector("#hb-earth-emoji")!;
        this.earthGif = this.querySelector("#hb-earth-gif")!;
        this.earthLink = this.querySelector("#hb-earth-link")!;
        this.earthPost = this.querySelector("#hb-earth-post")!;
        this.earthSecrets = this.querySelector("#hb-earth-secrets")!;
        this.earthTrove = this.querySelector("#hb-earth-trove")!;

        this.feedback = this.querySelector("#hb-feedback-container")!;
        this.feedbackButtons = this.querySelector("#hb-feedback-buttons")!;
        this.feedbackButton = this.querySelector("#hb-feedback-button")!;
        this.feedbackBug = this.querySelector("#hb-feedback-bug")!;
        this.feedbackSuggestion = this.querySelector(
            "#hb-feedback-suggestion"
        )!;
        this.feedbackHelp = this.querySelector("#hb-feedback-help")!;

        this.b3 = this.querySelector("#hb-3-container")!;
        this.b3Buttons = this.querySelector("#hb-3-buttons")!;
        this.b3Button = this.querySelector("#hb-3-button")!;
        this.b = this.b3Button.firstElementChild as SVGElement;
        this.broadcast = this.querySelector("#hb-3-broadcast")!;
        this.sos = this.querySelector("#hb-3-sos")!;
        this.sidekick = this.querySelector("#hb-3-sidekick")!;
        this.record = this.querySelector("#hb-3-record")!;
        this.reload = this.querySelector("#hb-3-reload")!;
        this.heartQuest = this.querySelector("#hb-heart-quest")!;
    }

    private async renderLocation(event?: Event) {
        await window.earth.getCurrentLocation();
        this.renderHeroes(true);
        this.footerContent.innerHTML = `<span class="animate-pulse">🔘</span> <span class="text-sm font-bold">Nearby Zero Heroes</span><br><em class="text-sm">${getAddress()}</span>`;
        if (event)
            alert(
                "Your current location has been updated along with Zero Heroes that are near you!"
            );
    }

    private renderFamilyBank() {}

    connectedCallback() {
        this.render();
        window.addEventListener("popstate", this.render.bind(this));

        this.addHeartListeners();
        this.addBankListeners();
        this.addEarthListeners();
        this.addFeedbackListeners();
        this.addB3Listeners();
        this.addTokenListeners();

        this.footerContent.addEventListener("click", async (event) => {
            if (this.selectedAction === "heart") this.renderLocation(event);
            else alert("Switching to another Family B-Bank coming soon!");
        });

        this.heartbank.addAuthStateListener(async (user) => {
            if (user) {
                this.hasPasskey = (await this.heartbank.passKeysCount()) > 0;
                this.user = new User(user);
                //this.user.saveTokenToFirestore(); // await // causes partial document

                //await this.user.initUser(); // doesn't work
                //await wait(1); // needed for broadcast icon to render correctly: TODO: later refactor to not use local storage
                //const profile = await this.hero.get();
                this.renderButtons();
            }

            this.banker =
                user?.email === "thonly@heartbank.ceo"
                    ? "+15626071498"
                    : "+15623945396";

            this.feedback.classList.toggle("hidden", this.heartbank.isAdmin());
            this.b3.classList.toggle("hidden", !this.heartbank.isAdmin());

            this.heart.classList.toggle("hidden", !user);
            this.bank.classList.toggle("hidden", !user);
            //this.heart.classList.remove("hidden");
            //this.bank.classList.remove("hidden");

            this.heartBroadcast.classList.toggle("hidden", !user);
            //this.broadcast.classList.toggle("hidden", !user);

            // this.bankTeller.classList.toggle(
            //     "hidden",
            //     this.heartbank.isBanker()
            // );
            // this.bankPool.classList.toggle(
            //     "hidden",
            //     !this.heartbank.isBanker()
            // );

            // for mom and che phone bc smaller screen due to large font
            this.heartGift.classList.toggle(
                "hidden",
                !this.heartbank.isAdmin()
            );
            this.heartPouch.classList.toggle(
                "hidden",
                !this.heartbank.isAdmin()
            );
            this.bankBlast.classList.toggle(
                "hidden",
                !this.heartbank.isAdmin()
            );
            this.bankPrice.classList.toggle(
                "hidden",
                !this.heartbank.isAdmin()
            );
        });

        this.addEventListener("hb-treasury", (e) => {
            if (!this.map.classList.contains("hidden"))
                this.earthButton.click();
            const event = e as CustomEvent<{ isShow: boolean }>;
            if (event.detail.isShow) {
                if (!this.heartButtons.classList.contains("flex"))
                    this.heartButton.click();
            } else {
                if (this.heartButtons.classList.contains("flex"))
                    this.heartButton.click();
                if (this.bankButtons.classList.contains("flex"))
                    this.bankButton.click();
            }
        });

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.addEventListener("message", (event) => {
                //console.log(event.data);
                if (event.data.action === "deeplink") {
                    const { b, minter, miner, hash } = event.data;

                    let text = "";
                    switch (b) {
                        case "m":
                            text = minter
                                ? `Would you like to view ${minter}'s B-Moment of Kindness mentioning you?`
                                : `Would you like to view your B-Moment of Kindness mentioning ${miner}?`;
                            break;
                        case "k":
                            text = miner
                                ? `Would you like to view your B-Thank to ${miner}?`
                                : `Would you like to view ${minter}'s B-Thank for you?`;
                            break;
                        case "t":
                            text = minter
                                ? `Would you like to view ${minter}'s B-Token of Appreciation for you?`
                                : `Would you like to view your B-Token of Appreciation to ${miner}?`;
                            break;
                    }

                    // TODO: remove when 100% working // iphone seems to skip this!
                    if (confirm(text)) window.location.hash = hash;
                }
            });
        }
    }

    private async renderButtons() {
        if (isTip()) {
            this.bankTip.classList.add("bg-orange-400");
            this.bankTip.classList.remove("bg-gray-400");
            this.bankButton.classList.add("animate-pulse");
        } else {
            this.bankTip.classList.remove("bg-orange-400");
            this.bankTip.classList.add("bg-gray-400");
            this.bankButton.classList.remove("animate-pulse");
        }

        const heart = this.heartButton.firstElementChild as SVGElement;
        if (isBroadcast()) {
            this.heartBroadcast.classList.add("bg-orange-400");
            this.heartBroadcast.classList.remove("bg-gray-400");
            heart.classList.add("animate-heartbeat");

            // this.broadcast.classList.add("bg-orange-400");
            // this.broadcast.classList.remove("bg-gray-400");
            // this.b.classList.add("animate-heartbeat");
        } else {
            this.heartBroadcast.classList.remove("bg-orange-400");
            this.heartBroadcast.classList.add("bg-gray-400");
            heart.classList.remove("animate-heartbeat");

            // this.broadcast.classList.remove("bg-orange-400");
            // this.broadcast.classList.add("bg-gray-400");
            // this.b.classList.remove("animate-heartbeat");
        }

        if (isSos()) {
            this.sos.classList.add("bg-orange-400");
            this.sos.classList.remove("bg-gray-400");
            //this.b3Button.classList.remove("ring-gray-500");
            //this.b3Button.classList.add("ring-orange-500");
            this.b3Button.classList.add("animate-pulse");
        } else {
            this.sos.classList.remove("bg-orange-400");
            this.sos.classList.add("bg-gray-400");
            //this.b3Button.classList.add("ring-gray-500");
            //this.b3Button.classList.remove("ring-orange-500");
            this.b3Button.classList.remove("animate-pulse");
        }

        if (isSidekick()) {
            this.sidekick.classList.add("bg-orange-400");
            this.sidekick.classList.remove("bg-gray-400");
            this.b3Button.classList.remove("bg-gray-400");
            this.b3Button.classList.add("bg-orange-500");
        } else {
            this.sidekick.classList.remove("bg-orange-400");
            this.sidekick.classList.add("bg-gray-400");
            this.b3Button.classList.add("bg-gray-400");
            this.b3Button.classList.remove("bg-orange-500");
        }

        if (isRecord()) {
            this.record.classList.add("bg-orange-400");
            this.record.classList.remove("bg-gray-400");
        } else {
            this.record.classList.remove("bg-orange-400");
            this.record.classList.add("bg-gray-400");
        }
    }

    // people nearby => use in anonymous nearby thanking
    private aquariusKiitos(kiitos: number, frequency: number) {
        const footer =
            kiitos === 0
                ? "♒️ To grow it further, continue to mint B-Appreciations for people nearby who have touched your heart, and mine B-Appreciations that are given to you in gratitude"
                : kiitos < 0
                  ? "♒️ Now, carry your gratitude forward by showing kindness to people nearby to earn their B-Appreciations and return back to Zero!"
                  : "♒️ Now, carry the gratitude that others have shown to you forward by minting B-Appreciations for people nearby to return back to Zero!";
        return `${this.getAquarius("Kiitos", kiitos, frequency)}\n\n${footer}`;
    }

    private aquariusKiitti(kiitti: number, frequency: number, life: number) {
        const footer =
            kiitti === 0
                ? "♒️ To grow it further, continue to capture B-Moments of Kindness on behalf of Miss Aquarius™ and humanity"
                : kiitti < 0
                  ? "♒️ Now, carry your gratitude forward by capturing your B-Moments of Kindness towards Miss Aquarius™ to return back to Zero!"
                  : "♒️ Now, carry the gratitude that Miss Aquarius™ has shown to you forward by capturing her B-Moments of Kindness to return back to Zero!";
        return `${this.getAquarius("Kiitti", kiitti, frequency)}\n\n${this.getAquarius2(life)}\n\n${footer}`;
    }

    private getAquarius(type: string, balance: number, frequency: number) {
        const [sign, karat] = balance.numberTuple() || ["", "Zero"];
        const aura =
            getAuraEmoji(frequency) +
            (type === "Kiitos" ? " INNER RING" : " OUTER RING");
        const header = type === "Kiitos" ? "INNER CIRCLE" : "OUTER CIRCLE";
        const footer = type === "Kiitos" ? "people nearby" : "all of life";
        if (balance === 0)
            return `${aura}: Your current ${type} Aura is ${getAuraName(frequency)}\n\n⭕️ ${header}: By returning back to Zero, your ${type} Aura Color has grown!`;
        else if (balance < 0)
            return `${aura}: Your current ${type} Aura is ${getAuraName(frequency)}\n\n🔻 ${header}: Your ${type} Balance is currently NEGATIVE ${karat} which means you have been ${getAdverb(
                balance
            )}appreciative towards ${footer}`;
        else
            return `${aura}: Your current ${type} Aura is ${getAuraName(frequency)}\n\n🔺 ${header}: Your ${type} Balance is currently POSITIVE ${karat} which means you have been ${getAdverb(
                balance
            )}kind towards ${footer}`;
    }

    private getAquarius2(balance: number) {
        const [sign, karat] = balance.numberTuple() || ["", "Zero"];
        const frequency = getRandomNumber(0, 100);
        const aura = `${getAuraEmoji(frequency)} EARTH: Miss Aquarius™'s current Aura is ${getAuraName(frequency)}`;
        if (balance === 0)
            return `${aura}\n\n⭕️ EARTH: By returning back to Zero, Miss Aquarius™'s Kiitti Aura Color has grown!`;
        else if (balance < 0)
            return `${aura}\n\n🔻 EARTH: Miss Aquarius™'s Kiitti Balance is currently NEGATIVE ${karat} which means she has been ${getAdverb(
                balance
            )}appreciative towards humankind`;
        else
            return `${aura}\n\n🔺 EARTH: Miss Aquarius™'s Kiitti Balance is currently POSITIVE ${karat} which means she has been ${getAdverb(
                balance
            )}kind towards humanity`;
    }

    // not used here but in cloud function
    private getStatus(kiitos: number) {
        if (kiitos === 0) return "at peace";
        if (kiitos > 0) return kiitos > 50 ? "super kind" : "kind";
        return kiitos < 50 ? "super grateful" : "grateful";
    }

    private getTipAmount(): string {
        const amount = localStorage.getItem("amount");
        return amount ? parseInt(amount).toCashAmount2() : "";
    }

    private addTokenListeners() {
        const tokens: Record<string, HTMLElement> = {
            red: this.redToken,
            orange: this.orangeToken,
            yellow: this.yellowToken,
            green: this.greenToken,
            blue: this.blueToken,
            indigo: this.indigoToken,
            violet: this.violetToken
        };

        Object.entries(tokens).forEach(([color, token]) => {
            enableTapAndLongPress(token);

            token.addEventListener("tap", () => {
                // const hero = getHero();
                // const account = hero.account || 0;
                // const fund = hero.fund || 0;
                // const balance = fund || account;
                //this.heartButton.click();
                //this.main.showToken(color, this.selectedHero, "0");
                window.location.hash = `#/token/${color}/${this.selectedHero}/0/${this.selectedAction === "bank" ? 1 : 0}`; //balance > 0 &&
            });

            token.addEventListener("longpress", async () => {
                if (this.selectedAction === "bank") {
                    const profile = await this.me.getUserProfile(
                        this.selectedHero
                    );
                    const name = this.me.getName2(profile);

                    if (this.heartbank.user && this.hasPasskey) {
                        const pool = await this.familyBank.getPool();
                        const account = getHero().account || 0;
                        const balance = this.heartbank.isMissAquarius()
                            ? pool || account
                            : account;
                        const isPool =
                            this.heartbank.isMissAquarius() && pool > 0;

                        if (balance > 0) {
                            const amount = prompt(
                                `🩷 How much would you like to anonymously ${isPool ? "reward" : "donate"} to ${name}'s B-Fund?\n\n🏦 Your Current ${isPool ? "B-Kitty" : "B-Account"} Balance: ${balance.toCashAmount3()}`,
                                this.getTipAmount() ||
                                    getRecommendedTipAmount(
                                        "donate",
                                        color,
                                        balance,
                                        profile.auraColor || 0,
                                        profile.auraSize || 0
                                    )
                            );
                            if (amount) {
                                if (amount.isNumeric()) {
                                    const cents = amount.toCents();
                                    if (cents <= balance) {
                                        const response = isPool
                                            ? await this.familyBank.reward(
                                                  this.selectedHero,
                                                  cents
                                              )
                                            : await this.familyBank.fund(
                                                  this.selectedHero,
                                                  cents
                                              );
                                        if (response.color === "green") {
                                            alert(
                                                `🎉 You have successfully ${isPool ? "rewarded" : "donated"} ${cents.toCashAmount3()} to ${name}'s B-Fund!\n\n🏦 Your New ${isPool ? "B-Kitty" : "B-Account"} Balance: ${(balance - cents).toCashAmount3()}\n\nNOTE: Your family and ${name} have been anonymously notified by push and email`
                                            );
                                            this.bankButton.click();
                                        } else if (response.color === "red")
                                            alert(response.text);
                                    } else {
                                        alert(
                                            `Donation amount cannot be more than ${balance.toCashAmount3()}`
                                        );
                                        token.dispatchEvent(
                                            new Event("longpress")
                                        );
                                    }
                                } else {
                                    alert("Please enter a dollar amount");
                                    token.dispatchEvent(new Event("longpress"));
                                }
                            }
                        } else
                            alert(
                                this.heartbank.isBanker()
                                    ? "You currently do not have any cash inside your Family B-Kitty or Personal B-Account from which to reward or donate"
                                    : "You currently do not have any cash inside your HeartBank® Personal Account from which to donate"
                            );
                    } else {
                        if (this.heartbank.user) {
                            if (
                                confirm(
                                    `Passkey is required to donate to ${name}'s B-Fund.\n\nWould you like to create one now?`
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-lockbox",
                                    window.location.hash
                                );
                                this.bankButton.click();
                                window.location.hash = "#/lockbox";
                            }
                        } else {
                            if (
                                confirm(
                                    `You need to be logged in to donate to ${name}'s B-Fund.\n\nWould you like to log in now?`
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-login",
                                    window.location.hash
                                );
                                this.bankButton.click();
                                window.location.hash = "#/login";
                            }
                        }
                    }
                } else {
                    //this.heartButton.click();
                    //this.main.showToken(color, this.selectedHero, "1");
                    window.location.hash = `#/token/${color}/${this.selectedHero}/1/0`;
                }
            });
        });
    }

    private addHeartListeners() {
        this.heartButton.addEventListener("click", () => {
            if (this.heartButtons.classList.contains("flex")) {
                this.selectedAction = null;
                this.heartButton.classList.remove("ring-4");
                this.heartButtons.classList.add("hidden");
                this.heartButtons.classList.remove("flex");

                this.heartKiitos.classList.add("hidden");
                this.bankCash.classList.remove("hidden");
                this.tokens.classList.add("hidden");
                this.heroes.classList.add("hidden");
                if (this.heartbank.user) this.bank.classList.remove("hidden");

                this.header.showNavbar();
                this.footer.showTabBar();
                if (this.heartbank.isAdmin())
                    this.b3.classList.remove("hidden");
                else this.feedback.classList.remove("hidden");
                this.earth.classList.remove("hidden");

                // footer
                this.footerContent.classList.add("hidden");
            } else {
                this.selectedAction = "heart";
                this.heartButton.classList.add("ring-4");
                this.heartButtons.classList.remove("hidden");
                this.heartButtons.classList.add("flex");

                this.heartKiitos.classList.remove("hidden");
                this.bankCash.classList.add("hidden");
                //this.tokens.classList.remove("hidden");
                this.heroes.classList.remove("hidden");
                if (this.heartbank.user) this.bank.classList.add("hidden");
                this.renderHeroes(true);
                this.selectedHero = "";

                // footer
                this.footerContent.classList.remove("hidden");
                this.renderLocation();

                this.header.hideNavbar();
                this.footer.hideTabBar();
                if (this.heartbank.isAdmin()) this.b3.classList.add("hidden");
                else this.feedback.classList.add("hidden");
                this.earth.classList.add("hidden");

                const hero = getHero();
                const kiitos = hero.kiitos?.numberTuple() || ["", "Zero"];
                const kiitti = hero.kiitti?.numberTuple() || ["", "Zero"];
                // this.kiitosSign.textContent =
                //     kiitos[0] === ""
                //         ? "⭕️ "
                //         : kiitos[0] === "+"
                //           ? "🟣 +"
                //           : "🟠 -";
                this.kiitosSign.innerHTML =
                    getAuraEmoji(hero.kiitosFrequency || 0) +
                    "&nbsp;&nbsp;" +
                    kiitos[0];
                this.kiitosKarat.textContent = kiitos[1];
                // this.kiittiSign.textContent =
                //     kiitti[0] === ""
                //         ? "⭕️ "
                //         : kiitti[0] === "+"
                //           ? "🟣 +"
                //           : "🟠 -";
                this.kiittiSign.innerHTML =
                    getAuraEmoji(hero.kiittiFrequency || 0) +
                    "&nbsp;&nbsp;" +
                    kiitti[0];
                this.kiittiKarat.textContent = kiitti[1];

                this.user?.saveTokenToFirestore(); // await // needed because token may expire
            }
        });

        const kiitos = this.heartKiitos.firstElementChild as HTMLElement;
        kiitos.addEventListener("click", () => {
            const kiitos = getHero().kiitos || 0;
            const frequency = getHero().kiitosFrequency || 0;
            alert(this.aquariusKiitos(kiitos, frequency));
        });

        const kiitti = this.heartKiitos.lastElementChild as HTMLElement;
        kiitti.addEventListener("click", async () => {
            const kiitti = getHero().kiitti || 0;
            const frequency = getHero().kiittiFrequency || 0;
            const life = await this.kiitti.getKiitti();
            alert(this.aquariusKiitti(kiitti, frequency, life));
        });

        this.heartChest.addEventListener("click", () => {
            this.heartButton.click();
            this.renderChest();
        });

        this.heartPouch.addEventListener("click", () => {});

        this.heartTreasure.addEventListener("click", () => {});

        this.heartThank.addEventListener("click", () => {
            this.heartButton.click();
            window.location.hash = "#/thank";
        });

        this.heartGift.addEventListener("click", () => {
            //this.heartButton.click();
            //window.location.hash = "#/mint/ship";
        });

        this.heartBroadcast.addEventListener("click", async () => {
            this.heartBroadcast.disabled = true;
            const heart = this.heartButton.firstElementChild as SVGElement;
            if (isBroadcast()) {
                await this.hero.updateBroadcast(false);
                this.heartBroadcast.classList.remove("bg-orange-400");
                this.heartBroadcast.classList.add("bg-gray-400");
                heart.classList.remove("animate-heartbeat");
                alert("Your location will now stop broadcasting.");
            } else {
                this.hero.updateBroadcast(true);
                this.heartBroadcast.classList.add("bg-orange-400");
                this.heartBroadcast.classList.remove("bg-gray-400");
                heart.classList.add("animate-heartbeat");
                alert(
                    "Your location will be broadcasted for nearby Zero Heroes to thank you!"
                );
            }
            this.heartBroadcast.disabled = false;
        });

        this.heartLeaderboard.addEventListener("click", () => {
            this.heartButton.click();
            window.location.hash = "#/leaderboard";
        });
    }

    private addBankListeners() {
        this.bankTip.addEventListener("click", async () => {
            this.bankTip.disabled = true;
            if (isTip()) {
                await this.hero.updateTip(false);
                this.bankTip.classList.remove("bg-orange-400");
                this.bankTip.classList.add("bg-gray-400");
                this.bankButton.classList.remove("animate-pulse");
                alert("Automatic B-Tipping is now off");
            } else {
                this.hero.updateTip(true);
                this.bankTip.classList.add("bg-orange-400");
                this.bankTip.classList.remove("bg-gray-400");
                this.bankButton.classList.add("animate-pulse");
                alert("Automatic B-Tipping is now turned on!");
            }
            this.bankTip.disabled = false;
        });

        this.bankButton.addEventListener("click", () => {
            if (this.bankButtons.classList.contains("flex")) {
                this.selectedAction = null;
                this.bankButton.classList.remove("ring-4");
                this.bankButtons.classList.add("hidden");
                this.bankButtons.classList.remove("flex");

                this.heartKiitos.classList.remove("hidden");
                this.bankCash.classList.add("hidden");
                this.tokens.classList.add("hidden");
                this.heroes.classList.add("hidden");
                this.heart.classList.remove("hidden");

                this.header.showNavbar();
                this.footer.showTabBar();
                if (this.heartbank.isAdmin())
                    this.b3.classList.remove("hidden");
                else this.feedback.classList.remove("hidden");
                this.earth.classList.remove("hidden");

                // footer
                this.footerContent.classList.add("hidden");
            } else {
                this.selectedAction = "bank";

                this.bankButton.classList.add("ring-4");
                this.bankButtons.classList.remove("hidden");
                this.bankButtons.classList.add("flex");

                this.heartKiitos.classList.add("hidden");
                this.bankCash.classList.remove("hidden");
                this.heroes.classList.remove("hidden");
                this.heart.classList.add("hidden");
                const total = this.renderHeroes();
                this.selectedHero = "";

                // footer
                this.footerContent.classList.remove("hidden");
                this.footerContent.innerHTML = `🏦 Ly Family B-Bank<br><span class="text-sm"><strong>${total}</strong> Members</span>`;

                this.header.hideNavbar();
                this.footer.hideTabBar();
                if (this.heartbank.isAdmin()) this.b3.classList.add("hidden");
                else this.feedback.classList.add("hidden");
                this.earth.classList.add("hidden");

                // fund
                const hero = getHero();
                this.account.textContent =
                    hero.account?.toCashAmount2() || "0.00";
                this.fund.textContent = hero.fund?.toCashAmount2() || "0.00";

                this.bankSend.classList.remove("bg-pink-300");
                this.bankSend.classList.add("bg-gray-400");

                this.bankDeposit.classList.toggle(
                    "bg-green-300",
                    !this.heartbank.isBanker()
                );
                this.bankDeposit.classList.toggle(
                    "bg-gray-400",
                    this.heartbank.isBanker()
                );

                this.bankWithraw.classList.toggle(
                    "bg-red-300",
                    !this.heartbank.isBanker()
                );
                this.bankWithraw.classList.toggle(
                    "bg-gray-400",
                    this.heartbank.isBanker()
                );

                // const pool = await this.familyBank.getPool();
                // this.bankPool.classList.toggle("bg-blue-300", pool > 0);
                // this.bankPool.classList.toggle("bg-gray-400", pool <= 0);
            }
        });

        const note =
            "➡️ Would you like to make a transfer from your Personal B-Account to your Retip B-Fund?";
        const note2 =
            "⬆️ Would you like to make a transfer from your Personal B-Account to your Personal B-Wallet?";
        const note3 =
            "⬇️ Would you like to make a transfer from your Personal B-Wallet to your Personal B-Account?";

        const account = this.bankCash.firstElementChild as HTMLElement;
        account.addEventListener("click", async () => {
            const balance = getHero().account?.toCashAmount2() || "0.00";
            const reserve = await this.familyBank.getReserve();
            if (
                confirm(
                    `🧧 Your Personal B-Account Balance is $${balance} which you can withdraw from or publicly or anonymously tip to anyone in your family\n\n🏦 Your Family B-Bank has $${reserve.toCashAmount2()} in reserve which represents the total cash under management by your Family Banker\n\nNOTE: At the beginning of each month, your Family Banker will conduct a formal bank audit to confirm that both your cash and digital deposits remain safe under his custody\n\n${balance === "0.00" ? note3 : note2}`
                )
            )
                alert("HeartBank® Wallet coming soon!");
        });

        const fundEl = this.bankCash.lastElementChild as HTMLElement;
        fundEl.addEventListener("click", async () => {
            const balance = getHero().fund?.toCashAmount2() || "0.00";
            const pool = await this.familyBank.getPool();
            const info = `💰 Your Retip B-Fund Balance is $${balance} which you can use to publicly or anonymously re-tip your family members\n\nNOTE: Your B-Fund will be deducted FIRST followed by your B-Account\n\n♒️ Your Family B-Kitty has $${pool.toCashAmount2()} which Miss Aquarius™ can use to anonymously reward your family members by donating to their Retip B-Fund`;
            if (this.selectedHero && this.heartbank.isBanker()) {
                const profile = await this.me.getUserProfile(this.selectedHero);
                const name = this.me.getName2(profile);
                const fund = profile.fund || 0;
                if (
                    confirm(
                        `${info}\n\n🏧 Would you like to make a deposit into ${name}'s B-Fund?`
                    )
                ) {
                    if (this.heartbank.user && this.hasPasskey) {
                        const amount = prompt(
                            `🏧 How much would you like to deposit into ${name}'s B-Fund?`,
                            this.getTipAmount()
                        );
                        if (amount) {
                            if (amount.isNumeric()) {
                                const cents = amount.toCents();
                                const response = await this.familyBank.deposit(
                                    this.selectedHero ||
                                        this.heartbank.user.uid,
                                    cents,
                                    false
                                );
                                if (response.color === "green") {
                                    alert(
                                        `🎉 You have successfully deposited ${cents.toCashAmount3()} into ${name}'s B-Fund!\n\n🏦 ${name}'s New Balance: ${(fund + cents).toCashAmount3()}\n\nNOTE: ${name} has been notified by push and email`
                                    );
                                    this.bankButton.click();
                                } else if (response.color === "red")
                                    alert(response.text);
                            } else {
                                alert("Please enter a dollar amount");
                                fundEl.click();
                            }
                        }
                    } else {
                        if (this.heartbank.user) {
                            if (
                                confirm(
                                    "Passkey is required to deposit cash into your HeartBank® Retip Fund.\n\nWould you like to create one now?"
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-lockbox",
                                    window.location.hash
                                );
                                this.bankButton.click();
                                window.location.hash = "#/lockbox";
                            }
                        } else {
                            if (
                                confirm(
                                    "You need to be logged in to deposit cash into your HeartBank® Retip Fund.\n\nWould you like to log in now?"
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-login",
                                    window.location.hash
                                );
                                this.bankButton.click();
                                window.location.hash = "#/login";
                            }
                        }
                    }
                }
            } else if (confirm(`${info}\n\n${note}`)) this.transfer();
        });

        this.bankSend.addEventListener("click", async () => {
            if (this.selectedHero) {
                const profile = await this.me.getUserProfile(this.selectedHero);
                const name = this.me.getName2(profile);

                if (this.heartbank.user && this.hasPasskey) {
                    const account = getHero().account || 0;
                    if (account > 0) {
                        const amount = prompt(
                            `💵 How much would you like to privately send to ${name}'s B-Account?\n\n🏦 Your Current B-Account Balance: ${account.toCashAmount3()}`,
                            this.getTipAmount()
                        );
                        if (amount) {
                            if (amount.isNumeric()) {
                                const cents = amount.toCents();
                                if (cents <= account) {
                                    const response = await this.familyBank.send(
                                        this.selectedHero,
                                        cents
                                    );
                                    if (response.color === "green") {
                                        alert(
                                            `🎉 You have successfully sent ${cents.toCashAmount3()} to ${name}'s B-Account!\n\n🏦 Your New B-Account Balance: ${(account - cents).toCashAmount3()}\n\nNOTE: ${name} has been privately notified by push and email`
                                        );
                                        this.bankButton.click();
                                    } else if (response.color === "red")
                                        alert(response.text);
                                } else {
                                    alert(
                                        `Send amount cannot be more than ${account.toCashAmount3()}`
                                    );
                                    this.bankSend.click();
                                }
                            } else {
                                alert("Please enter a dollar amount");
                                this.bankSend.click();
                            }
                        }
                    } else
                        alert(
                            "You currently do not have any cash inside your HeartBank® Personal Account from which to send"
                        );
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                `Passkey is required to send to ${name}'s B-Account.\n\nWould you like to create one now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            this.bankButton.click();
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                `You need to be logged in to send to ${name}'s B-Account.\n\nWould you like to log in now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            this.bankButton.click();
                            window.location.hash = "#/login";
                        }
                    }
                }
            } else
                alert(
                    "⬇️ Please select the person below to who's B-Account you would like to send money"
                );
        });

        this.bankDeposit.addEventListener("click", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                if (this.heartbank.isBanker()) {
                    let name, account, note;
                    if (this.selectedHero) {
                        const profile = await this.me.getUserProfile(
                            this.selectedHero
                        );
                        name = this.me.getName2(profile);
                        account = profile.account || 0;
                        note = `${name} has been notified by push and email`;
                        name = name + "'s";
                    } else {
                        name = "your";
                        account = getHero().account || 0;
                        note = "A receipt has been sent to your email";
                    }

                    const amount = prompt(
                        `🏧 How much would you like to deposit into ${name} B-Account?`,
                        this.getTipAmount()
                    );
                    if (amount) {
                        if (amount.isNumeric()) {
                            const cents = amount.toCents();
                            const response = await this.familyBank.deposit(
                                this.selectedHero || this.heartbank.user.uid,
                                cents,
                                true
                            );
                            if (response.color === "green") {
                                alert(
                                    `🎉 You have successfully deposited ${cents.toCashAmount3()} into ${name} B-Account!\n\n🏦 ${name.capitalize()} New Balance: ${(account + cents).toCashAmount3()}\n\nNOTE: ${note}`
                                );
                                this.bankButton.click();
                            } else if (response.color === "red")
                                alert(response.text);
                        } else {
                            alert("Please enter a dollar amount");
                            this.bankDeposit.click();
                        }
                    }
                } else {
                    const amount = prompt(
                        "🏧 How much would you like to deposit into your HeartBank® Personal Account?\n\nNOTE: For cash deposit, please see Dad in person; otherwise, send via Zelle to thonly@siliconwat.dev",
                        this.getTipAmount()
                    );
                    if (amount) {
                        this.bankButton.click();
                        window.open(
                            `sms:${this.banker}?body=${encodeURIComponent(`I have sent $${amount} via Zelle. Please deposit it into my Personal B-Account`)}`
                        );
                        // after: banker gives success update
                    }
                }
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to deposit cash into your HeartBank® Personal Account.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to deposit cash into your HeartBank® Personal Account.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.bankWithraw.addEventListener("click", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                if (this.heartbank.isBanker()) {
                    let name, account, note;
                    if (this.selectedHero) {
                        const profile = await this.me.getUserProfile(
                            this.selectedHero
                        );
                        name = this.me.getName2(profile);
                        account = profile.account || 0;
                        note = `${name} has been notified by push and email`;
                        name = name + "'s";
                    } else {
                        name = "your";
                        account = getHero().account || 0;
                        note = "A receipt has been sent to your email";
                    }

                    if (account > 0) {
                        const amount = prompt(
                            `🏧 How much would you like to withdraw from ${name} B-Account?\n\n🏦 ${name.capitalize()} Current Balance: ${account.toCashAmount3()}`,
                            this.getTipAmount()
                        );
                        if (amount) {
                            if (amount.isNumeric()) {
                                const cents = amount.toCents();
                                if (cents <= account) {
                                    const response =
                                        await this.familyBank.withdraw(
                                            this.selectedHero ||
                                                this.heartbank.user.uid,
                                            cents
                                        );
                                    if (response.color === "green") {
                                        const balance = account - cents;
                                        alert(
                                            `🎉 You have successfully withdrew ${cents.toCashAmount3()} from ${name} B-Account!\n\n🏦 ${name.capitalize()} New Balance: ${balance.toCashAmount3()}\n\nNOTE: ${note}`
                                        );
                                        this.bankButton.click();
                                    } else if (response.color === "red")
                                        alert(response.text);
                                } else {
                                    alert(
                                        `Withdrawal amount cannot be more than ${account.toCashAmount3()}`
                                    );
                                    this.bankWithraw.click();
                                }
                            } else {
                                alert("Please enter a dollar amount");
                                this.bankWithraw.click();
                            }
                        }
                    } else
                        alert(
                            "You currently do not have any cash inside your HeartBank® Personal Account from which to withdraw"
                        );
                } else {
                    const account = getHero().account || 0;
                    const amount = prompt(
                        `🏧 How much would you like to withdraw from your HeartBank® Personal Account?\n\n🏦 Your Current Balance: ${account.toCashAmount3()}\n\nNOTE: For cash withrawal, please see Dad in person`,
                        this.getTipAmount() // || account.toCashAmount2()
                    );
                    if (amount) {
                        this.bankButton.click();
                        window.open(
                            `sms:${this.banker}?body=${encodeURIComponent(`I would like to withdraw $${amount} from my Personal B-Account via Zelle`)}`
                        );
                        // after: banker asks for Zelle email address for first time!
                    }
                }
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to withdraw cash from your HeartBank® Personal Account.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to withdraw cash from your HeartBank® Personal Account.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.bankTeller.addEventListener("click", () => {
            const question = prompt(
                "What question would you like to ask your Family Banker?"
            );
            if (question) {
                this.bankButton.click();
                window.open(
                    `sms:${this.banker}?body=${encodeURIComponent(question)}`
                );
            }
        });

        this.bankPool.addEventListener("click", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                const account = getHero().account || 0;
                if (account > 0) {
                    const amount = prompt(
                        `♒️ How much would you like to anonymously donate to your Family B-Kitty?\n\n🏦 Your Current B-Account Balance: ${account.toCashAmount3()}`,
                        this.getTipAmount() || account.toCashAmount2()
                    );
                    if (amount) {
                        if (amount.isNumeric()) {
                            const cents = amount.toCents();
                            if (cents <= account) {
                                const response =
                                    await this.familyBank.donate(cents);
                                if (response.color === "green") {
                                    alert(
                                        `🎉 You have successfully donated ${cents.toCashAmount3()} to your Family B-Kitty!\n\n🏦 Your New B-Account Balance: ${(account - cents).toCashAmount3()}\n\n♒️ Your New B-Kitty Balance: ${response.pool?.toCashAmount3()}\n\nNOTE: Your family members have been anonymously notified by push and email`
                                    );
                                    this.bankButton.click();
                                } else if (response.color === "red")
                                    alert(response.text);
                            } else {
                                alert(
                                    `Donation amount cannot be more than ${account.toCashAmount3()}`
                                );
                                this.bankPool.click();
                            }
                        } else {
                            alert("Please enter a dollar amount");
                            this.bankPool.click();
                        }
                    }
                } else
                    alert(
                        "You currently do not have any cash inside your HeartBank® Personal Account from which to donate"
                    );
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to donate to your Family B-Kitty.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to donate to your Family B-Kitty.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        this.bankButton.click();
                        window.location.hash = "#/login";
                    }
                }
            }
        });
    }

    private async transfer() {
        if (this.heartbank.user && this.hasPasskey) {
            const account = getHero().account || 0;
            const fund = getHero().fund || 0;

            if (account > 0) {
                const amount = prompt(
                    `➡️ How much would you like to transfer from your B-Account to your B-Fund?\n\n🏦 Your Current B-Account Balance: ${account.toCashAmount3()}\n\nNOTE: Transfers from your B-Account to your B-Fund cannot be reversed`,
                    this.getTipAmount() || account.toCashAmount2()
                );
                if (amount) {
                    if (amount.isNumeric()) {
                        const cents = amount.toCents();
                        if (cents <= account) {
                            const response =
                                await this.familyBank.transfer(cents);
                            if (response.color === "green") {
                                const accountBalance = account - cents;
                                const fundBalance = fund + cents;
                                alert(
                                    `🎉 You have successfully transferred ${cents.toCashAmount3()} from your B-Account to your B-Fund!\n\n🧧 Your New B-Account Balance: ${accountBalance.toCashAmount3()}\n\n💰 Your New B-Fund Balance: ${fundBalance.toCashAmount3()}\n\nNOTE: A receipt has been sent to your email`
                                );
                                this.bankButton.click();
                            } else if (response.color === "red")
                                alert(response.text);
                        } else {
                            alert(
                                `Transfer amount cannot be more than ${account.toCashAmount3()}`
                            );
                            this.transfer();
                        }
                    } else {
                        alert("Please enter a dollar amount");
                        this.transfer();
                    }
                }
            } else
                alert(
                    "You currently do not have any cash inside your HeartBank® Personal Account from which to transfer"
                );
        } else {
            if (this.heartbank.user) {
                if (
                    confirm(
                        "Passkey is required to make a transfer from your HeartBank® Personal Account.\n\nWould you like to create one now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-lockbox",
                        window.location.hash
                    );
                    this.bankButton.click();
                    window.location.hash = "#/lockbox";
                }
            } else {
                if (
                    confirm(
                        "You need to be logged in to make a transfer from your HeartBank® Personal Account.\n\nWould you like to log in now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-login",
                        window.location.hash
                    );
                    this.bankButton.click();
                    window.location.hash = "#/login";
                }
            }
        }
    }

    private addEarthListeners() {
        this.earthButton.addEventListener("click", () => {
            if (this.map.classList.contains("hidden")) {
                this.earthButton.classList.add("ring-4");
                this.earthButtons.classList.remove("hidden");
                this.earthButtons.classList.add("flex");

                if (this.heartbank.isAdmin()) this.b3.classList.add("hidden");
                else this.feedback.classList.add("hidden");

                this.map.classList.remove("hidden");
                this.header.hideNavbar();
                this.footer.hideTabBar();
                this.main.classList.remove("flex");
                this.main.classList.add("hidden");
                this.map.render(this.heartbank.user);
            } else {
                this.earthButton.classList.remove("ring-4");
                this.earthButtons.classList.add("hidden");
                this.earthButtons.classList.remove("flex");

                if (this.heartbank.isAdmin())
                    this.b3.classList.remove("hidden");
                else this.feedback.classList.remove("hidden");

                this.map.classList.add("hidden");
                this.header.showNavbar();
                this.footer.showTabBar();
                this.main.classList.add("flex");
                this.main.classList.remove("hidden");
            }
        });

        this.earthTree.addEventListener("click", () => {
            alert(`Global Family Tree coming soon!`);
        });

        this.earthPixxiKat.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/pixxikat";
        });

        this.earthEmoji.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/emoji";
        });

        this.earthGif.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/gif";
        });

        this.earthPost.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/post";
        });

        this.earthLink.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/link";
        });

        this.earthTrove.addEventListener("click", () => {
            this.earthButton.click();
            window.location.hash = "#/trove";
        });

        this.earthSecrets.addEventListener("click", () => {
            //this.earthButton.click();
            //window.location.hash = "#/mint/ship";
            //alert(`B-Note and B-Secret coming soon!`);
        });
    }

    private addFeedbackListeners() {
        // this.feedbackButton.addEventListener("click", () => {
        //     if (this.feedbackButtons.classList.contains("flex")) {
        //         this.feedbackButton.classList.remove("ring-4");
        //         this.feedbackButtons.classList.add("hidden");
        //         this.feedbackButtons.classList.remove("flex");
        //     } else {
        //         this.feedbackButton.classList.add("ring-4");
        //         this.feedbackButtons.classList.remove("hidden");
        //         this.feedbackButtons.classList.add("flex");
        //     }
        // });

        this.feedbackBug.addEventListener("click", () => {
            this.feedbackButton.click();
            alert(`Bug reporting coming soon!`);
        });

        this.feedbackSuggestion.addEventListener("click", () => {
            this.feedbackButton.click();
            alert(`Feedback coming soon!`);
        });

        this.feedbackHelp.addEventListener("click", () => {
            this.feedbackButton.click();
            alert(`Help coming soon!`);
        });
    }

    // admin only
    private addB3Listeners() {
        this.b3Button.addEventListener("click", () => {
            if (this.map.classList.contains("hidden")) {
                this.b3Buttons.classList.add("flex");
                this.b3Buttons.classList.remove("hidden");
                this.b3Button.classList.add("ring-4");

                this.earthButton.classList.add("hidden");

                this.map.classList.remove("hidden");
                this.header.hideNavbar();
                this.footer.hideTabBar();
                this.main.classList.remove("flex");
                this.main.classList.add("hidden");
                this.map.render(this.heartbank.user);

                //window.earth.getCurrentLocation();
            } else {
                this.b3Buttons.classList.remove("flex");
                this.b3Buttons.classList.add("hidden");
                this.b3Button.classList.remove("ring-4");

                this.earthButton.classList.remove("hidden");

                this.map.classList.add("hidden");
                this.header.showNavbar();
                this.footer.showTabBar();
                this.main.classList.add("flex");
                this.main.classList.remove("hidden");
            }
        });

        this.broadcast.addEventListener("click", async () => {
            this.broadcast.disabled = true;
            if (isBroadcast()) {
                await this.hero.updateBroadcast(false);
                this.broadcast.classList.remove("bg-orange-400");
                this.broadcast.classList.add("bg-gray-400");
                this.b.classList.remove("animate-heartbeat");
                alert("Your location will now stop broadcasting.");
            } else {
                this.hero.updateBroadcast(true);
                this.broadcast.classList.add("bg-orange-400");
                this.broadcast.classList.remove("bg-gray-400");
                this.b.classList.add("animate-heartbeat");
                alert(
                    "Your location will be broadcasted for nearby Zero Heroes to thank you!"
                );
            }
            this.broadcast.disabled = false;
        });

        this.sos.addEventListener("click", async () => {
            this.sos.disabled = true;
            if (isSos()) {
                await this.hero.updateSos(false);
                this.sos.classList.remove("bg-orange-400");
                this.sos.classList.add("bg-gray-400");
                //this.b3Button.classList.add("ring-gray-500");
                //this.b3Button.classList.remove("ring-orange-500");
                this.b3Button.classList.remove("animate-pulse");
                alert("3 will stop checking in on you.");
            } else {
                this.hero.updateSos(true);
                this.sos.classList.add("bg-orange-400");
                this.sos.classList.remove("bg-gray-400");
                //this.b3Button.classList.remove("ring-gray-500");
                //this.b3Button.classList.add("ring-orange-500");
                this.b3Button.classList.add("animate-pulse");
                alert("3 will now start checking in on you every 30 minutes.");
            }
            this.sos.disabled = false;
        });

        this.sidekick.addEventListener("click", async () => {
            this.sidekick.disabled = true;
            if (isSidekick()) {
                await this.hero.updateSidekick(false);
                this.sidekick.classList.remove("bg-orange-400");
                this.sidekick.classList.add("bg-gray-400");
                this.b3Button.classList.add("bg-gray-400");
                this.b3Button.classList.remove("bg-orange-500");
                alert("3 will now stop following you.");
            } else {
                this.hero.updateSidekick(true);
                this.sidekick.classList.add("bg-orange-400");
                this.sidekick.classList.remove("bg-gray-400");
                this.b3Button.classList.remove("bg-gray-400");
                this.b3Button.classList.add("bg-orange-500");
                alert(
                    "Your loyal sidekick, 3 AI, will start following you to keep you safe."
                );
            }
            this.sidekick.disabled = false;
        });

        this.record.addEventListener("click", async () => {
            this.record.disabled = true;
            if (isRecord()) {
                await this.hero.updateRecord(false);
                this.record.classList.remove("bg-orange-400");
                this.record.classList.add("bg-gray-400");
                alert("Your location will now stop recording.");
            } else {
                this.hero.updateRecord(true);
                this.record.classList.add("bg-orange-400");
                this.record.classList.remove("bg-gray-400");
                alert("Your location will now be recorded.");
            }
            this.record.disabled = false;
        });

        this.heartQuest.addEventListener("click", () => {
            this.b3Button.click();
            this.renderRock();
        });

        this.reload.addEventListener("click", () => window.location.reload());
    }

    private resetHeroes() {
        for (const button of this.heroes.children) {
            button.firstElementChild?.classList.remove("animate-pulse");
        }
    }

    private getHeroes(isNearby: boolean, maxMiles = 10) {
        const { lat, lng } = getPosition();
        const heroes = JSON.parse(localStorage.getItem("heroes") || "[]");

        return isNearby
            ? heroes.filter((hero: any) => {
                  if (!hero.address) return false;

                  const distance = haversineMiles(
                      lat,
                      lng,
                      hero.latitude,
                      hero.longitude
                  );

                  return distance <= maxMiles;
              })
            : heroes;
    }

    private renderHeroes(isNearby = false): number {
        this.heroes.innerHTML = "";
        let heroes = this.getHeroes(isNearby);
        heroes = [...heroes].sort((a, b) => (a.kiitos ?? 0) - (b.kiitos ?? 0));

        let total = this.heartbank.isMissAquarius() ? 0 : 1;
        for (const hero of heroes) {
            if (
                hero.isBroadcast && // this.selectedAction === "bank" ||
                (this.heartbank.isMissAquarius() ||
                    hero.uid !== this.heartbank.user?.uid)
            ) {
                total += 1;
                const name =
                    hero.displayName ||
                    hero.heartkey?.truncate2(15) ||
                    hero.trustkey?.truncate2(15) ||
                    "No Name";

                const img = document.createElement("img");
                img.style.borderColor = getKiitosAuraColor(
                    hero.kiitosFrequency
                );
                img.style.borderWidth = getKiitosAuraSize(
                    hero.kiitosFrequency,
                    "s"
                );
                img.style.boxShadow = `0 0 0 ${getKiittiAuraSize(hero.kiittiAmplitude, "s")} ${getKiittiAuraColor(hero.kiittiFrequency)}`;
                img.classList.add(
                    "w-11",
                    "h-11",
                    "rounded-full"
                    //"ring-3",
                    //"ring-white",
                    //"border-3",
                    //"border-white",
                    //"shadow-[0_0_0_5px_white]",
                    //getKiittiAuraColor(hero.kiittiFrequency),
                    //getKiittiAuraSize(hero.kiittiAmplitude, "s"),
                    //ringColors[Math.floor(Math.random() * ringColors.length)]
                );
                img.style.background = getAuraColor(
                    hero.kiitosFrequency,
                    hero.kiittiFrequency
                );
                img.src = hero.photoURL || avatar;

                const button = document.createElement("button");
                button.type = "button";
                button.className =
                    "snap-start shrink-0 flex-shrink-0 bg2-gray-400 opacity-90 flex items-center justify-center rounded-full w-14 h-14 focus:outline-none";

                //TODO: long press => tip
                button.addEventListener("click", () => {
                    if (img.classList.contains("animate-pulse")) {
                        img.classList.remove("animate-pulse");
                        this.selectedHero = "";
                        this.tokens.classList.add("hidden");
                        this.footerContent.classList.remove("hidden");

                        this.bankSend.classList.remove("bg-pink-300");
                        this.bankSend.classList.add("bg-gray-400");

                        if (this.heartbank.isBanker()) {
                            this.bankDeposit.classList.remove("bg-green-300");
                            this.bankDeposit.classList.add("bg-gray-400");

                            this.bankWithraw.classList.remove("bg-red-300");
                            this.bankWithraw.classList.add("bg-gray-400");
                        }
                    } else {
                        this.resetHeroes();
                        img.classList.add("animate-pulse");
                        this.selectedHero = hero.uid;
                        this.tokens.classList.remove("hidden");
                        this.footerContent.classList.add("hidden");

                        this.bankSend.classList.add("bg-pink-300");
                        this.bankSend.classList.remove("bg-gray-400");

                        if (this.heartbank.isBanker()) {
                            this.bankDeposit.classList.add("bg-green-300");
                            this.bankDeposit.classList.remove("bg-gray-400");

                            this.bankWithraw.classList.add("bg-red-300");
                            this.bankWithraw.classList.remove("bg-gray-400");
                        }
                    }

                    // if (hero.photoURL) {
                    //     const note = prompt(
                    //         `Add an anonymous thank-you note for ${name}: `,
                    //         "No thank-you note equals 1 Kiitos"
                    //     );
                    //     if (note) alert(`1 Kiitos has been sent to ${name}!`);
                    // } else {
                    //     const note = prompt(
                    //         `Add an anonymous thank-you note for ${name}: `,
                    //         "No thank-you note equals $1 USD"
                    //     );
                    //     if (note) alert(`$1 USD has been sent to ${name}!`);
                    // }
                });

                button.appendChild(img);
                this.heroes.appendChild(button);
            }
        }

        return total;
    }

    private render() {
        const paths = window.location.pathname.split("/");
        const fragments = window.location.hash.split("/");
        console.log(paths, fragments);

        switch (paths[1]) {
            case "3":
                //window.open("app-link", "_self");
                //window.location.href = "app-link";
                break;
            case "B":
                window.location.href = B;
                //window.open("https://x.com/@heartbank", "_self");
                break;
            case "THonly":
                window.location.href = "https://thonly.org";
                //window.open("https://thonly.org", "_self");
                break;

            case "wa":
                window.location.href = "https://wa.me/18005984265";
                //window.open("https://wa.me/18005984265", "_self");
                break;
            case "x":
                window.location.href = "https://x.com/@heartbank";
                //window.open("https://x.com/@heartbank", "_self");
                break;
            case "facebook":
                window.location.href = "https://www.facebook.com/heartbank";
                //window.open("https://x.com/@heartbank", "_self");
                break;
            case "yt":
                window.location.href = "https://youtube.com/@heartbank";
                //window.open("https://youtube.com/@heartbank", "_self");
                break;

            case "thank": // tokens: tags
                this.renderTag(paths[2]);
                break;
            case "gram": // tokens: chests
                this.renderChest(paths[2]);
                break;
            case "aquarius": // moments + quest
                this.renderRock(paths[2]);
                break;
            default: // tokens: grams
                if (paths[1] in grams) this.renderGram(grams[paths[1]]);
        }

        this.renderHash(fragments[1], fragments);
        if (isPopup) {
            this.header.hideNavbar();
            this.footer.hideTabBar();
            //this.main.showMainChest();
            //this.main.showDiamond();
        }
    }

    // b-tag for tipping
    private async renderTag(username?: string) {
        this.main.showSpinner();
        await this.heartbank.waitForAuth();
        const gram = username ? grams[username] : null;
        this.hasPasskey = (await this.heartbank.passKeysCount()) > 0; // needed bc race condition

        if (gram && this.heartbank.user && this.hasPasskey) {
            if (
                this.heartbank.user.uid ===
                gram[isProduction ? "live" : "local"][0]
            ) {
                if (gram.moment)
                    localStorage.setItem("moment-gold", gram.moment);
                window.location.href =
                    window.location.origin + "#/aquarius/quest";
            } else {
                const miner = await this.me.getUserProfile(
                    gram[isProduction ? "live" : "local"][0]
                );
                this.main.tip(miner, gram?.tip || "");
            }
        } else {
            if (!this.hasPasskey) {
                if (
                    confirm(
                        "Passkey is required to give this B-Tip.\n\nWould you like to create one now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-lockbox",
                        window.location.hash
                    );
                    window.location.href = window.location.origin + "#/lockbox";
                } else window.location.href = window.location.origin;
            } else if (!this.heartbank.user) {
                if (
                    confirm(
                        "You need to be logged in to give this B-Tip.\n\nWould you like to log in now?"
                    )
                ) {
                    localStorage.setItem(
                        "redirect-login",
                        window.location.hash
                    );
                    window.location.href = window.location.origin + "#/login";
                } else window.location.href = window.location.origin;
            } else {
                alert("Sorry, this B-Tag is not authentic");
                window.location.href = window.location.origin;
            }
        }

        this.main.hideSpinner();
    }

    // b-journal
    private async renderRock(username?: string) {
        if (username) {
            this.main.showSpinner();
            await this.heartbank.waitForAuth();
            const moment = await this.kiitti.getRock(
                grams[username]
                    ? grams[username][isProduction ? "live" : "local"][0]
                    : ""
            );
            if (moment.cursor) window.tokenCursor = moment.cursor;
            this.main.hideSpinner();

            if (moment.data) {
                history.pushState(
                    null,
                    "",
                    `${window.location.origin}/#/aquarius/${moment.data.id}`
                );
                this.main.showDear(moment.data, false);
            } else {
                window.location.href = window.location.origin + "/#/aquarius";
            }

            // window.location.href =
            //     window.location.origin +
            //     (moment.data ? `/#/aquarius/${moment.data.id}` : "/#/aquarius");
        } else {
            const username = getHero().username;
            if (username)
                localStorage.setItem("moment-gold", `Thanks @${username}`);
            window.location.href = "/#/aquarius/quest";
        }
    }

    // family
    private async renderChest(username?: string) {
        this.main.showSpinner();
        const gram = grams[username || "thonly"];
        const token = await this.thanks.getChest("");
        if (token.cursor) window.tokenCursor = token.cursor;
        this.main.hideSpinner();

        if (token.data) {
            history.pushState(
                null,
                "",
                `${window.location.origin}/#/token/${token.data.id}/chest`
            );
            this.main.showToken(token.data, "chest", "0", false);
        } else {
            window.location.href =
                window.location.origin +
                `/#/token/yellow/${isProduction ? gram.live[1] : gram.local[1]}/0/0`;
        }

        // window.location.href =
        //     window.location.origin +
        //     (token.data
        //         ? `/#/token/${token.data.id}/chest`
        //         : `/#/token/yellow/${isProduction ? gram.live[0] : gram.local[0]}/0/0`);
    }

    // lovers: gem
    private async renderGram(gram: Gram) {
        this.main.showSpinner();
        const token = isProduction
            ? await this.thanks.getGram(gram.live[0], gram.live[1])
            : await this.thanks.getGram(gram.local[0], gram.local[1]);
        if (token.cursor) window.tokenCursor = token.cursor;
        this.main.hideSpinner();

        if (token.data) {
            history.pushState(
                null,
                "",
                `${window.location.origin}/#/token/${token.data.id}/gram`
            );
            this.main.showToken(token.data, "gram", "0", false);
        } else {
            window.location.href =
                window.location.origin +
                `/#/token/yellow/${isProduction ? gram.live[1] : gram.local[1]}/0/0`;
        }

        // window.location.href =
        //     window.location.origin +
        //     (token.data
        //         ? `/#/token/${token.data.id}/gram`
        //         : `/#/token/yellow/${isProduction ? gram.live[1] : gram.local[1]}/0/0`);
    }

    // private async renderGram(gram: Gram) {
    //     this.main.showSpinner();
    //     const token1 = isProduction
    //         ? await this.thanks.getGram(gram.live[0], gram.live[1])
    //         : await this.thanks.getGram(gram.local[0], gram.local[1]);
    //     const token2 = isProduction
    //         ? await this.thanks.getGram(gram.live[1], gram.live[0])
    //         : await this.thanks.getGram(gram.local[1], gram.local[0]);

    //     // latest token
    //     let token;
    //     if (token1 && token2) {
    //         token = token1.date! > token2.date! ? token1 : token2;
    //     } else if (token1) {
    //         token = token1;
    //     } else if (token2) {
    //         token = token2;
    //     } else {
    //         token = null;
    //     }

    //     //this.heartbank.user?.uid === token?.from
    //     this.main.hideSpinner();

    //     window.location.href =
    //         window.location.origin +
    //         (token
    //             ? `/#/token/${token.id}/${isProduction ? gram.live[0] : gram.local[0]}`
    //             : `/#/token/yellow/${isProduction ? gram.live[1] : gram.local[1]}/0/0`);
    // }

    // pages
    private async renderHash(hash: string, fragments: string[]) {
        await this.heartbank.waitForAuth();

        this.header.hideOnboard();
        this.header.hideMenu();
        this.header.hideLockbox();
        this.header.hideLocker();
        this.header.hideSafe();
        this.header.hideHold();
        this.header.hideChest();
        this.header.hideFactory();

        this.main.hideVideo();
        this.main.hideVault();
        this.main.hideMine();
        this.main.hideDear();

        this.main.hideShip();
        this.main.hideSilver();
        this.main.hideJewel();
        this.main.hideX();

        this.main.hideLeaderboard();
        this.main.hideThank();
        this.main.hideToken();

        this.main.hidePixxiKat();
        this.main.hideEmoji();
        this.main.hideGif();
        this.main.hidePost();
        this.main.hideLink();
        this.main.hideTrove();

        this.footer.hideLogin();
        this.footer.hideSignin();
        this.footer.hideHumanity();
        this.footer.hideFeatures();
        this.footer.hidePhone();
        this.footer.hideAbout();

        switch (hash) {
            case "onboard":
                this.header.showOnboard(fragments[2]);
                break;
            case "video": // pwa, steps, etc!
                this.main.showVideo(fragments[2]);
                break;
            case "menu":
                this.header.showMenu();
                break;
            case "about": // safety, security, privacy, terms, etc!
                this.footer.showAbout(fragments[2]);
                //this.main.openHB("com", "privacy");
                break;

            case "vault":
                this.main.showVault(fragments[2] as "mint" | "mine");
                break;
            case "chest":
                this.header.showChest(fragments[2], fragments[3]);
                break;
            case "mint":
                switch (fragments[2]) {
                    case "ship":
                        this.main.showShip();
                        break;
                    case "silver":
                        this.main.showSilver();
                        break;
                    case "jewel":
                        this.main.showJewel();
                        break;
                    case "chest":
                        this.main.showX(fragments[3]);
                        break;
                }
                break;
            case "aquarius":
                this.main.showDear(fragments[2], fragments[3] === "boost");
                break;
            case "mine":
                this.main.showMine(fragments[2]);
                break;
            case "stamp":
                const stamp = await this.stamps.get(fragments[2]);
                if (stamp) {
                    if (stamp.chest) {
                        window.location.hash = `#/mine/${stamp.chest}`;
                    } else {
                        if (this.heartbank.user) {
                            const heartkeysCount = parseInt(
                                localStorage.getItem("heartkeysCount") || "0"
                            );
                            if (heartkeysCount) {
                                if (
                                    confirm(
                                        "Would you like to mint this brand new HeartBank® Stamp?" // Silver ?
                                    )
                                ) {
                                    localStorage.setItem("storage", "cloud");
                                    localStorage.setItem("stamp", stamp.id!);
                                    window.location.hash = "#/mint/ship";
                                }
                            } else if (
                                confirm(
                                    "A Safe is required to mint a HeartBank® Stamp.\n\nWould you like to create one now?"
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-safes",
                                    window.location.hash
                                );
                                window.location.hash = "#/safes";
                            }
                        } else {
                            if (
                                confirm(
                                    "You need to be logged in to mint a HeartBank® Stamp.\n\nWould you like to log in now?"
                                )
                            ) {
                                localStorage.setItem(
                                    "redirect-login",
                                    window.location.hash
                                );
                                window.location.hash = "#/login";
                            }
                        }
                    }
                }
                break;

            case "lockers":
                this.header.showLocker();
                break;
            case "safes":
                if (this.heartbank.user) this.header.showSafe();
                else window.location.hash = "#/login";
                break;
            case "lockbox":
                if (this.heartbank.user) this.header.showLockbox();
                else window.location.hash = "#/login";
                break;
            case "keyhold":
                if (this.heartbank.isAdmin()) this.header.showHold();
                else window.location.hash = "#/login";
                break;

            case "factory":
                if (this.heartbank.isMonk()) this.header.showFactory();
                else window.location.hash = "#/login";
                break;
            // TODO: remove // for testing only
            case "sign":
                if (this.heartbank.user) this.header.sign();
                else window.location.hash = "#";
                break;
            case "encrypt":
                if (this.heartbank.user) this.header.encrypt();
                else window.location.hash = "#";
                break;
            case "decrypt":
                if (this.heartbank.user) this.header.decrypt();
                else window.location.hash = "#";
                break;

            case "login":
                if (!this.heartbank.user)
                    isRunningAsPWA
                        ? this.footer.showSignin()
                        : this.footer.showLogin();
                else window.location.hash = "#";
                break;
            case "passkey":
                if (!this.heartbank.user) this.header.login();
                else window.location.hash = "#";
                break;
            case "logout": // need to relay data to opener or iframe
                if (confirm("Are you sure you want to log out?")) {
                    this.user?.logout();
                    this.header.logout();
                }
                break;

            case "features":
                this.footer.showFeatures();
                break;
            case "notary":
                break;
            case "scans":
                break;
            case "logs":
                break;
            case "humanity":
                if (this.heartbank.user) this.footer.showHumanity(fragments[2]);
                else window.location.hash = "#/login";
                break;
            case "phone":
                if (this.heartbank.user) this.footer.showPhone();
                else window.location.hash = "#/login";
                break;

            case "leaderboard":
                this.main.showLeaderboard();
                break;
            case "thank":
                this.main.showThank(fragments[2]);
                break;
            case "token":
                this.main.showToken(
                    fragments[2],
                    fragments[3],
                    fragments[4],
                    fragments[5] === "1"
                );
                break;

            case "pixxikat":
                this.main.showPixxiKat(fragments[2], fragments[3]);
                break;
            case "emoji":
                this.main.showEmoji(fragments[2], fragments[3]);
                break;
            case "gif":
                this.main.showGif(fragments[2], fragments[3]);
                break;
            case "post":
                this.main.showPost(fragments[2]);
                break;
            case "link":
                this.main.showLink(fragments[2]);
                break;
            case "trove":
                this.main.showTrove(fragments[2]);
                break;
        }
    }
}
